exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail[data-v-86bd3302]{border-left:2px solid #e9e9e9}[data-v-86bd3302] .fileButton{display:none}", ""]);

// exports
